import { render, staticRenderFns } from "./checkOrderInfo.vue?vue&type=template&id=307874a7&scoped=true&"
import script from "./checkOrderInfo.vue?vue&type=script&lang=js&"
export * from "./checkOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./checkOrderInfo.vue?vue&type=style&index=0&id=307874a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307874a7",
  null
  
)

export default component.exports